<div style="text-align:center" >
  <!-- Group 1: Dropdown Filters (Left Side) -->
  <div class="filter-actions-line" style="box-shadow: none !important; background-color: rgba(255, 255, 255, 0.8) !important; ">
    <!-- Market Filter -->
    @if (visibleFilters().includes('market')) {
    <mat-form-field appearance="outline">
      <mat-label>Market</mat-label>
      <mat-select [(ngModel)]="currentFilters.market"
       (selectionChange)="onFilterChange('market')"
                  name="market" data-testid="market" (openedChange)="onMarketDropdownOpened($event, marketSearchInput)">
        <div class="mat-select-search-container" (click)="$event.stopPropagation()">
          <input #marketSearchInput matInput placeholder="Search Market..." (input)="filterMarkets($event)"
                 class="mat-select-search-input" aria-label="Search Market" (keydown)="$event.stopPropagation();" />
          <mat-icon class="mat-select-search-icon">search</mat-icon>
        </div>
        @for (market of filteredMarkets(); track $index) {
        <mat-option [value]="market.id">{{ market.regionName }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    }

    <!-- Generator Filter -->
    @if (visibleFilters().includes('generator')) {
    <mat-form-field appearance="outline">
      <mat-label>Customer</mat-label>
      <mat-select [(ngModel)]="currentFilters.generator"
                  (selectionChange)="onFilterChange('generator')"
                  [disabled]="!currentFilters.market"
                  [compareWith]="compareIds"
                  name="generator"
                  (openedChange)="onGeneratorDropdownOpened($event, genSearchInput)">
        <div class="mat-select-search-container" (click)="$event.stopPropagation()">
          <input #genSearchInput matInput placeholder="Search Customer..." (input)="filterGenerators($event)"
                 class="mat-select-search-input" aria-label="Search Customer" (click)="$event.stopPropagation()"
                 (keydown)="$event.stopPropagation();" />
          <mat-icon class="mat-select-search-icon">search</mat-icon>
        </div>
        <mat-option [value]="null">-- All Customers --</mat-option>
        @for (generator of filteredGenerators(); track  $index) {
        <mat-option [value]="generator.id">{{ generator.generatorName }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    }

    <!-- Stream Filter -->
    @if (visibleFilters().includes('stream')) {
    <mat-form-field appearance="outline">
      <mat-label>Streams</mat-label>
      <mat-select [(ngModel)]="currentFilters.streamid"
                  (selectionChange)="onFilterChange('stream')"
                  [disabled]="!currentFilters.generator"
                  name="stream"
                  (openedChange)="onStreamDropdownOpened($event, streamSearchInput)">
        <div class="mat-select-search-container" (click)="$event.stopPropagation()">
          <input #streamSearchInput matInput placeholder="Search Stream..." (input)="filterStreams($event)"
                 class="mat-select-search-input" aria-label="Search Stream" (keydown)="$event.stopPropagation();" />
          <mat-icon class="mat-select-search-icon">search</mat-icon>
        </div>
        @for (stream of filteredStreams(); track  $index) {
        <mat-option [value]="stream.streamId">{{ stream.streamName }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    }
    @if(canAdd){
      <button [attr.id]="'addItem' + addButtonText" [attr.data-testid]="'addItem' + addButtonText"
              mat-raised-button color="primary" (click)="addClicked.emit()">
        Add {{ addButtonText }}
      </button>
    }

    @if(this.displayExistingStreams() && canAddExisting){
      <button [attr.id]="'addExistingStream'" [attr.data-testid]="'addExistingStream' + addButtonText"
        mat-raised-button color="primary" (click)="existingStreamsClicked.emit()">
        Add Existing Stream
      </button>
    }

    <div appearance="outline" class="filter-field-width custom-search-box">
      <mat-icon matPrefix>search</mat-icon>
      <input matInput [value]="currentFilters.searchText" (input)="onSearchInput($event)" [placeholder]="searchPlaceholder">
    </div>
  </div>
  <!-- Group 2: Action Controls (Right Side) -->
    
</div>
